import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraLogo } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { User } from 'lucide-react';
import { memo } from 'react';
export const MessageAvatar = /*#__PURE__*/ memo(function MessageAvatar({ isAssistant, variant = 'default' }) {
    if (variant === 'assist') {
        return /*#__PURE__*/ _jsx("div", {
            className: `mt-px flex h-[22px] w-[22px] flex-shrink-0 items-center justify-center ${isAssistant ? 'rounded-[6px] bg-muted' : 'rounded-full bg-primary text-primary-foreground'}`,
            children: isAssistant ? /*#__PURE__*/ _jsx(SpecraLogo, {
                variant: "mark",
                size: 12,
                label: ""
            }) : /*#__PURE__*/ _jsx(User, {
                className: "h-3 w-3"
            })
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": Testids.assistant.messageAvatar,
        className: `w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${isAssistant ? 'bg-muted' : 'bg-primary text-primary-foreground'}`,
        children: isAssistant ? /*#__PURE__*/ _jsx(SpecraLogo, {
            variant: "mark",
            size: 20,
            label: "Assistant"
        }) : /*#__PURE__*/ _jsx(User, {
            className: "w-4 h-4"
        })
    });
});
